import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polygon, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const PolygonMap = ({ serviceableAreas, nonServiceableAreas }) => {
  const [serviceableCoords, setServiceableCoords] = useState([]);
  const [nonServiceableCoords, setNonServiceableCoords] = useState([]);

  // Helper: parse FeatureCollection or Polygon GeoJSON
  const parseGeoJson = geoJsonStr => {
    try {
      if (!geoJsonStr) return [];

      const parsed = JSON.parse(geoJsonStr);

      // ✅ Case 1: FeatureCollection
      if (parsed.type === 'FeatureCollection' && Array.isArray(parsed.features)) {
        const coords = [];
        parsed.features.forEach(feature => {
          if (feature.geometry?.type === 'Polygon' && Array.isArray(feature.geometry.coordinates)) {
            feature.geometry.coordinates.forEach(ring => {
              coords.push(ring.map(([lng, lat]) => [lat, lng]));
            });
          }
        });
        return coords;
      }

      // ✅ Case 2: Simple Polygon
      if (parsed.type === 'Polygon' && Array.isArray(parsed.coordinates)) {
        return [parsed.coordinates[0].map(([lng, lat]) => [lat, lng])];
      }

      return [];
    } catch (err) {
      console.error('Invalid GeoJSON', err);
      return [];
    }
  };

  useEffect(() => {
    setServiceableCoords(parseGeoJson(serviceableAreas));
  }, [serviceableAreas]);

  useEffect(() => {
    setNonServiceableCoords(parseGeoJson(nonServiceableAreas));
  }, [nonServiceableAreas]);

  return (
    <div style={{ height: '663px', width: '100%' }}>
      <MapContainer center={[28.6, 77.2]} zoom={5} style={{ height: '100%', width: '100%' }}>
        <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" attribution='&copy; <a href="https://carto.com/">CARTO</a>' />

        {/* Serviceable Area (Blue) */}
        {serviceableCoords.map((coords, idx) => (
          <React.Fragment key={`s-${idx}`}>
            <Polygon positions={coords} pathOptions={{ color: 'blue', fillOpacity: 0.4 }} />
            {idx === 0 && <FitBounds coords={coords} />}
          </React.Fragment>
        ))}

        {/* Non-Serviceable Area (Red) */}
        {nonServiceableCoords.map((coords, idx) => (
          <React.Fragment key={`ns-${idx}`}>
            <Polygon positions={coords} pathOptions={{ color: 'red', fillOpacity: 0.4 }} />
            {!serviceableCoords.length && idx === 0 && <FitBounds coords={coords} />}
          </React.Fragment>
        ))}
      </MapContainer>
    </div>
  );
};

// Helper to auto-fit map bounds
const FitBounds = ({ coords }) => {
  const map = useMap();
  useEffect(() => {
    if (coords.length > 0) {
      map.fitBounds(coords);
    }
  }, [coords, map]);
  return null;
};

export default PolygonMap;
